import React from 'react';
export function Footer() {
  return <footer className="border-t border-charcoal/10 py-12" data-id="element-77">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-78">
        <div className="flex items-center gap-8" data-id="element-79">
          <a href="#" className="label-tiny text-charcoal/50 hover:text-charcoal transition-colors duration-500" data-id="element-80">
            אינסטגרם
          </a>
          <a href="#" className="label-tiny text-charcoal/50 hover:text-charcoal transition-colors duration-500" data-id="element-81">
            פייסבוק
          </a>
        </div>

        <div className="flex flex-col items-center" data-id="element-82">
          <span className="serif-latin text-xl tracking-[0.15em] text-charcoal mb-2" data-id="element-83">
            AURÉ
          </span>
        </div>

        <div data-id="element-84">
          <span className="label-tiny text-charcoal/40" data-id="element-85">
            © 2026 AURÉ. כל הזכויות שמורות.
          </span>
        </div>
      </div>
    </footer>;
}